module.exports = __webpack_public_path__ + "img/surveyExcel.91c9b674.png";